module.exports = __webpack_public_path__ + "static/media/powerButton.a1b50952.svg";